import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Toast } from 'primeng/toast';
import { TypographyComponent } from '@components/ui-components/typography/typography.component';
import { ActionBtnComponent } from '@components/action-components/action-btn/action-btn.component';
import { TranslationPipe } from '@pipes/translation.pipe';
import { ActionLinkComponent } from '@components/action-components/action-link/action-link.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-message-toast',
  standalone: true,
  imports: [
    Toast,
    TypographyComponent,
    ActionBtnComponent,
    TranslationPipe,
    ActionLinkComponent,
  ],
  templateUrl: './message-toast.component.html',
  styleUrl: './message-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageToastComponent {
  protected readonly router = inject(Router);

  isWhiteColor(type: string) {
    return type === 'error' ? 'white' : 'black';
  }
}
